import React, { useState, useEffect } from "react";
import { ethers } from "ethers";
import Swal from 'sweetalert2';
import { Tabs, Tab, Card, Button, InputGroup, Form } from "react-bootstrap";
import { FaCheck, FaRegUserCircle, FaStore  } from 'react-icons/fa';

function MarketPlace() {
    const [privateKey, setPrivateKey] = useState('');
    const [contractAddress, setContractAddress] = useState('');
    const [setPriceInput, setSetPriceInput] = useState('');
    const [setPaymentPriceInput, setSetPaymentPriceInput] = useState('');
    const [setNameInput, setSetNameInput] = useState('');
    const [transactionHash, setTransactionHash] = useState('');
    const [storedValue, setStoredValue] = useState(null);
    const [storedValueList, setStoredValueList] = useState(null);
    const [itemId, setItemId] = useState('');
    const [selectedAccount, setSelectedAccount] = useState("");
    const [accounts, setAccounts] = useState([]);

    useEffect(() => {
        async function loadAccounts() {
            if(!window.ethereum){
                Swal.fire("RALAT!!", "Sila Install MetaMAsk!", "error");
                return;
            }

            try{
                const provider = new ethers.providers.Web3Provider(window.ethereum);
                const accounts = await provider.listAccounts();
                setAccounts(accounts);
                setSelectedAccount(accounts[0])
            } catch {
                console.log("Error fetching account list");
            }
        }
        loadAccounts();
    }, []);

    const deployContract = async() => {
        try{
            if(privateKey){
                console.log(privateKey);
                Swal.fire({ 
                    title: "Waiting for response from server!",
                    html: "please wait!<br>",
                    allowOutsideClick: false,
                    didOpen: () => {
                      Swal.showLoading();
                    },
                });
                const response = await fetch('http://localhost:4000/deploy-contract-marketplace', {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify({privateKey}),
                });

                if(response.ok){
                    Swal.close();
                    Swal.fire("BERJAYA!!", "Alamat Kontrak Berjaya Dicipta", "success");
                    const data = await response.json();
                    setContractAddress(data.address);
                } else {
                    Swal.close();
                    Swal.fire("AMARAN!!", "Terdapat ralat dalam mewujudkan Alamat Kontrak", "error");
                    console.error('Deployment failed');
                }
            } else {
                Swal.fire("RALAT!!", "Kesilapan sistem", "error");
                console.error('Private Key is required');
            }
        } catch(error) {
            Swal.fire("RALAT!!", "Kesilapan sistem", "error");
            console.error('Failed to deploy contract', error);
        }
    };

    const setNewValue = async() => {
        try{
            if(setPriceInput && setNameInput){
                Swal.fire({ 
                    title: "Waiting for response from server!",
                    html: "please wait!<br>",
                    allowOutsideClick: false,
                    didOpen: () => {
                      Swal.showLoading();
                    },
                });
                const response = await fetch('http://localhost:4000/list-item', {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify({
                        privateKey: privateKey,
                        contractAddress: contractAddress,
                        name: setNameInput,
                        price: setPriceInput
                    }),
                });

                if(response.ok){
                    Swal.close();
                    Swal.fire("BERJAYA!!", "Barang telah ditambah di stor", "success");
                    const { itemId, transactionHash } = await response.json();
                    setItemId(itemId);
                    setTransactionHash(transactionHash);
                } else {
                    Swal.close();
                    Swal.fire("RALAT!!", "Terdapat kesilapan pada kemasukkan barang", "warning");
                    console.error('Deployment failed');
                }
            } else {
                Swal.fire("RALAT!!", "Kesilapan sistem", "error");
                console.error('Name and Price is required');
            }
        } catch(error) {
            Swal.fire("RALAT!!", "Kesilapan sistem", "error");
            console.error('Failed to deploy contract', error);
        }
    };

    const updateItem = async() => {
        try{
            console.log('Update');
            const response = await fetch('http://localhost:4000/update-item', {
                method: 'PUT',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    privateKey: privateKey,
                    contractAddress: contractAddress,
                    itemId: itemId,
                    name: setNameInput,
                    price: setPriceInput
                }),
            });

            if(response.ok){
                const { transactionHash } = await response.json();
                setTransactionHash(transactionHash);
            } else {
                console.error('Deployment failed');
            }
        } catch(error) {
            Swal.fire("RALAT!!", "Kesilapan sistem", "error");
            console.error('Failed to deploy contract', error);
        }
    };

    const deleteItem = async() => {
        try{
            console.log("DELETE");
            const response = await fetch('http://localhost:4000/delete-item?itemId=${itemId}&privateKey=${privateKey}&,contractAddress=${contractAddress}', {
                method: 'DELETE',
                headers: {'Content-Type': 'application/json'},
            });

            if(response.ok){
                const { transactionHash} = await response.json();
                setTransactionHash(transactionHash);
            } else {
                console.error('Deployment failed');
            }
        } catch(error) {
            Swal.fire("RALAT!!", "Kesilapan sistem", "error");
            console.error('Failed to deploy contract', error);
        }
    };

    const getValue = async () => {
        try {
            const response = await fetch(`http://localhost:4000/read-item?itemId=${itemId}&contractAddress=${contractAddress}`);

            if (response.ok) {
                const data = await response.json();
                const result = data;
                setStoredValue(result);
                setSetPriceInput(result['price']);
            } else {
                console.error('Getting value failed');
            }
        } catch (error) {
            Swal.fire("RALAT!!", "Kesilapan sistem", "error");
            console.error('Error while getting value:', error);
        }
    };

    const makePayment = async () => {
        try {
            if (setPaymentPriceInput) {
                console.log(setPaymentPriceInput);
                console.log(setPriceInput);
                if(setPaymentPriceInput==setPriceInput){
                    const response = await fetch('http://localhost:4000/buy-item', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            privateKey: privateKey,
                            contractAddress: contractAddress,
                            value: setPaymentPriceInput,
                            itemId: itemId
                        }),
                    });

                    if (response.ok) {
                        const {transactionHash}= await response.json();
                        setTransactionHash(transactionHash);
                    } else {
                        console.error('Deployment failed');
                    }
                } else {
                    Swal.fire("KESILAPAN!!", "Bayaran mesti lebih besar dari Harga", "warning");
                    console.error('Payment price is not the same as item price !');
                }
            } else {
                Swal.fire("RALAT!!", "Kesilapan sistem", "error");
                console.error('Payment price is required for deployment.');
            }
        } catch (error) {
            Swal.fire("RALAT!!", "Kesilapan sistem", "error");
            console.error('Error during deployment:', error);
        }
    };

    return (
        <>
        <h1>Market Place</h1>
        <Tabs defaultActiveKey="deploy" id="justify-tab" className="mb-3" justify>
            <Tab eventKey="deploy" title="Deploy Contract">
                <Card>
                    <Card.Header style={{ backgroundColor:'#191970', color:'yellow', textAlign:'center' }}>
                        Alamat Kontrak
                    </Card.Header>
                    <Card.Body>
                        <div>
                            <InputGroup className="mb-3">
                                <InputGroup.Text id="basic-addon1">
                                Private Key
                                </InputGroup.Text>
                                <Form.Control id="privateKey" aria-describedby="basic-addon1" value={privateKey} onChange={(e)=>setPrivateKey(e.target.value)}  />
                            </InputGroup>
                            <InputGroup className="mb-3">
                                <InputGroup.Text id="basic-addon2">
                                Contract Address
                                </InputGroup.Text>
                                <Form.Control id="contractAddress" aria-describedby="basic-addon2" value={contractAddress} onChange={(e)=>setContractAddress(e.target.value)} />
                            </InputGroup>
                            <div style={{textAlign:'right'}}>
                                <Button variant='info' onClick={deployContract}><FaRegUserCircle /> Deploy Contract</Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </Tab>
            <Tab eventKey="crud" title="CRUD Item Value">
                <Card>
                    <Card.Header style={{ backgroundColor:'#191970', color:'yellow', textAlign:'center' }}>
                        CRUD Item Value
                    </Card.Header>
                    <Card.Body>
                        <div>
                            <InputGroup className="mb-3">
                                <InputGroup.Text id="basic-addon3">
                                Private Key
                                </InputGroup.Text>
                                <Form.Control id="privateKey" aria-describedby="basic-addon3" value={privateKey} onChange={(e)=>setPrivateKey(e.target.value)}  />
                            </InputGroup>
                            <InputGroup className="mb-3">
                                <InputGroup.Text id="basic-addon4">
                                Name Item
                                </InputGroup.Text>
                                <Form.Control id="itemName" aria-describedby="basic-addon4" value={setNameInput} onChange={(e)=>setSetNameInput(e.target.value)}  />
                            </InputGroup>
                            <InputGroup className="mb-3">
                                <InputGroup.Text id="basic-addon5">
                                Price
                                </InputGroup.Text>
                                <Form.Control id="itemPrice" aria-describedby="basic-addon5" value={setPriceInput} onChange={(e)=>setSetPriceInput(e.target.value)}  />
                            </InputGroup>
                            <InputGroup className="mb-3">
                                <InputGroup.Text id="basic-addon6">
                                Transaction Hash
                                </InputGroup.Text>
                                <Form.Control id="transactionHash" aria-describedby="basic-addon6" value={transactionHash} onChange={(e)=>setTransactionHash(e.target.value)}  />
                            </InputGroup>
                            <div style={{textAlign:'right'}}>
                                <Button variant='info' onClick={setNewValue}><FaStore /> Set Value</Button>
                                <Button variant='warning' onClick={updateItem} disabled={itemId==''}><FaRegUserCircle /> Update Item</Button>
                                <Button variant='danger' onClick={deleteItem} disabled={itemId==''}><FaCheck /> Delete Item</Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </Tab>
            <Tab eventKey="item" title="Item Detail">
                <Card>
                    <Card.Header style={{ backgroundColor:'#191970', color:'yellow', textAlign:'center' }}>
                        Item Detail
                    </Card.Header>
                    <Card.Body>
                        <div>
                            <InputGroup className="mb-3">
                                <InputGroup.Text id="basic-addon7">
                                Item ID
                                </InputGroup.Text>
                                <Form.Control id="itemId" aria-describedby="basic-addon7" value={itemId} onChange={(e)=>setItemId(e.target.value)}  />
                            </InputGroup>
                            <div className="outercontainer">
                                <div className="labell">Item Name :</div> 
                                <div className="answer">{(storedValue!=null)?storedValue.name:''}</div>
                            </div>
                            <div className="outercontainer">
                                <div className="labell">Item Price :</div> 
                                <div className="answer">{(storedValue!=null)?storedValue.price:''}</div>
                            </div>
                            <div className="outercontainer">
                                <div className="labell">Is Sold :</div> 
                                <div className="answer">{(storedValue!=null)?(storedValue.sold)?"Yes":"No":''}</div>
                            </div>
                            <div style={{textAlign:'right'}}>
                                <Button variant='success' onClick={getValue}><FaRegUserCircle /> Get Value</Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </Tab>
            <Tab eventKey="marketplace" title="Pay for item">
                <Card>
                    <Card.Header style={{ backgroundColor:'#191970', color:'yellow', textAlign:'center' }}>
                        Pay for item
                    </Card.Header>
                    <Card.Body>
                        <div>
                            <div className="outercontainer">
                                <div className="labell">Item Name :</div> 
                                <div className="answer">{(storedValue!=null)?storedValue.name:''}</div>
                            </div>
                            <div className="outercontainer">
                                <div className="labell">Item Price :</div> 
                                <div className="answer">{(storedValue!=null)?storedValue.price:''}</div>
                            </div>
                            <InputGroup className="mb-3">
                                <InputGroup.Text id="basic-addon8">
                                Pay Price
                                </InputGroup.Text>
                                <Form.Control id="setPriceInput" aria-describedby="basic-addon8" value={setPaymentPriceInput} onChange={(e)=>setSetPaymentPriceInput(e.target.value)}  />
                            </InputGroup>
                            <div style={{textAlign:'right'}}>
                                <Button variant='success' onClick={makePayment}><FaRegUserCircle /> Make Payment</Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </Tab>
        </Tabs>
        </>
    )
}

export default MarketPlace;